import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { ProposalDetails } from 'src/app/_types/proposals.type';
import { InsuranceFlowStatus } from 'src/app/enums/insurance-flow/insurance-flow-status.enum';
import { ProposalState } from 'src/app/enums/proposal.enums';
import { SendProposalsModalComponent } from 'src/app/shared/components/view-proposals/send-proposals-modal/send-proposals-modal.component';
import { IconsModule } from 'src/app/shared/icons/icons.module';

import { BaseStepperAction } from '../base-action';

/**
 * Sending one offer moves the affaire to PENDING_OFFERS; the drafts left behind must still be
 * sendable together, until an accepted offer clears them.
 */
const SENDABLE_STATUSES: readonly InsuranceFlowStatus[] = [
  InsuranceFlowStatus.PREPARING_OFFERS,
  InsuranceFlowStatus.PENDING_OFFERS,
];

@Component({
  selector: 'app-send-proposals-action',
  standalone: true,
  imports: [
    CommonModule,
    NgbTooltipModule,
    SendProposalsModalComponent,
    IconsModule,
  ],
  templateUrl: './send-proposals.component.html',
})
export class SendProposalsActionComponent extends BaseStepperAction {
  get enabled() {
    return (
      this.proposals?.filter(
        (x) => x.proposalState === ProposalState.PROPOSAL_SAVED
      ).length > 0 &&
      SENDABLE_STATUSES.includes(this.state?.insuranceFlowData?.status)
    );
  }

  get proposals(): ProposalDetails[] {
    return this.state?.proposals;
  }
}
